<template>
  <router-view/>
</template>

<style lang="scss">
*::-webkit-scrollbar {
  display: none;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
body,html{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "SansSc", sans-serif;
  #app{
    width: 100%;
    height: 100%;
  }
}
@media screen and (max-width: 1920px) {
  .pageBlock{
    width: calc(100% - 80px * 2) !important;
    padding: 40px 80px !important;
  }
  .header{
    justify-content: space-between !important;
  }
}
/* 小屏到中屏（例如常见手机） */
@media (min-width: 375px) {
  html { font-size: 100%; } /* 仍为16px，或设置 14px 取决设计 */
}

/* 中等屏（小笔电 / 大手机） */
@media (min-width: 768px) {
  html { font-size: 112.5%; } /* 18px (16 * 1.125) */
}

/* 桌面常见（1024 ~ 1440） */
@media (min-width: 1024px) {
  html { font-size: 125%; } /* 20px */
}

/* 宽屏/高清（>=1440） */
@media (min-width: 1440px) {
  html { font-size: 137.5%; } /* 22px */
}

/* 超宽（>=1920） */
@media (min-width: 1920px) {
  html { font-size: 140%; } /* 24px */
}
.pageTitle{
  font-size:1.3rem;
  position: relative;
  padding-left:10px;
  .homeBlockSubTitle{
    font-size: 2rem;
    color: rgba(134, 134, 134, 0.1);
    transform: translateY(-20px);
    font-weight: 600;
  }
}
.pageTitle::after{
  content: "";
  width: 4px;
  height: 50%;
  background: linear-gradient(to bottom , #2255FE , rgba(#2255FE,0) 80%);
  position: absolute;
  left: 0;
  top: 5px;
}
.pageBlock{
  padding: 40px 0;
  width: 100%;
  max-width: 1920px;
  min-width:1200px;
  margin: 0 auto;
}
.pageBlockBac{
  width: 100%;
  background-color: #F2F5F9;
}
.el-pagination{
  gap:10px;
  font-size: 0.5rem !important;
  .el-pager{
    gap:10px;
    .number{
      border: 1px solid #C1C1C1;
      transition: all .2s;
    }
    .number:hover{
      background-color: #0B60DC;
      color: white;
    }
  }
  .btn-next,.btn-prev{
    border: 1px solid #C1C1C1 !important;
    padding: 0 12px !important;
    transition: all .2s;
  }
  .btn-next:not(:disabled):hover,.btn-prev:not(:disabled):hover{
    background-color: #0B60DC;
    color: white !important;
  }
}
.el-select{
  .el-select__wrapper{
    height: 40px !important;
    border-radius: 30px;
    box-shadow: 0 0 0 1px #878787 !important;
    .el-select__icon,.el-select__placeholder{
      color: #262626 !important;
    }
  }
}
</style>
